import { sendExceptionToSentry } from './shared/helpers/sentry';
import { IFrameHelper } from './widget/helpers/utils';

const vueAppEnv = process.env.VUE_APP_WIDGET_ENV;
const isBuddyEnv = process.env.VUE_APP_IS_BUDDY_ENV;

export const initGainSight = (tenant) => {
  window.hiver_tenant = tenant;
  const getGainsightAPIKey = () => {
    if (vueAppEnv === 'dev' || isBuddyEnv === 'true') {
      return 'AP-7KSJ96CLI4DB-2-3';
    }
    return 'AP-7KSJ96CLI4DB-2';
  };

  (function(n, t, a, e, co) {
    let i = 'aptrinsic';
    (n[i] =
      n[i] ||
      function() {
        (n[i].q = n[i].q || []).push(arguments);
      }),
      (n[i].p = e);
    n[i].c = co;
    let r = t.createElement('script');
    (r.async = !0), (r.src = a + '?a=' + e);
    let c = t.getElementsByTagName('script')[0];
    c.parentNode.insertBefore(r, c);
  })(
    window,
    document,
    'https://web-sdk.aptrinsic.com/api/aptrinsic.js',
    getGainsightAPIKey(),
    { iframeModeEnabled: false }
  );
};

const getGainsightCommonData = () => {
  const url = new URL(window.location.href);
  const pageUrl = IFrameHelper.inIframe() ? document.referrer : `${url.origin}${url.pathname}`;
  const deviceType = getDeviceType();
  return { pageUrl, deviceType }
}

export const sendGainSightEvent = (event, data = {}) => {
  try {
    if (window.aptrinsic) {
      data.HIVER_INBOX_ID = window?.HIVER_INBOX_ID;
      const commonData = getGainsightCommonData();
      window.aptrinsic('track', event, { ...commonData, ...data, tenant: window.hiver_tenant });
    }
  } catch (e) {
    console.error('Aptrinsic tracking call failed', e);
    sendExceptionToSentry(e);
  }
};

export const getDeviceType = () => {
  const userAgent = navigator.userAgent;
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i;
  if (mobileRegex.exec(userAgent)) {
    return 'Mobile';
  } else {
    return 'Desktop';
  }
};

export const isRepeatUser = userData => {
  const isRepeat = !!userData?.email;
  localStorage.setItem(
    GAIN_SIGHT_CONSTANTS.IS_REPEAT_USER_CHAT_CONVERSATION_TRIGGERED,
    isRepeat
  );
  return isRepeat;
};

export const handleLiveChatGainSight = async (event, pageUrl, user) => {
  const repeatUser = isRepeatUser(user);
  const data = {
    pageUrl,
    deviceType: getDeviceType(),
    repeatUser
  };
  sendGainSightEvent(event, data);
};

export const handleChatBotGainSight = (event, data) => {
  if (
    event === CHATBOTS_GAINSIGHT_EVENTS.CHATBOT_CLOSED_CHAT &&
    data?.messages[0]?.sender_type ===
      GAIN_SIGHT_CONSTANTS.SENDER_TYPE_AGENT_BOT &&
    data?.status === GAIN_SIGHT_CONSTANTS.CHAT_STATUS_RESOLVED &&
    data?.messages[0]?.content_attributes?.items?.target_node_id !== null
  ) {
    sendGainSightEvent(CHATBOTS_GAINSIGHT_EVENTS.CHATBOT_CLOSED_CHAT);
  } else if (
    event === CHATBOTS_GAINSIGHT_EVENTS.CHAT_HANDOFF_TO_AGENT &&
    data?.status === GAIN_SIGHT_CONSTANTS.CHAT_STATUS_OPEN &&
    data?.messages[0]?.content_attributes?.items?.target_node_id === null &&
    data?.messages[0]?.sender_type ===
      GAIN_SIGHT_CONSTANTS.SENDER_TYPE_AGENT_BOT
  ) {
    sendGainSightEvent(CHATBOTS_GAINSIGHT_EVENTS.CHAT_HANDOFF_TO_AGENT);
  }
};

export const handleLiveChatConvTriggerEvent = data => {
  if (data?.messages[0]?.content !== null && data?.messages?.length !== 0) {
    const isRepeatUser =
      localStorage.getItem(
        GAIN_SIGHT_CONSTANTS.IS_REPEAT_USER_CHAT_CONVERSATION_TRIGGERED
      ) === GAIN_SIGHT_CONSTANTS.TRUE;
    const chatConvTriggerData = {
      endUserEmailId: data?.meta?.sender?.email,
      sourceOfEndUser: data?.additional_attributes?.referer?.split('?')?.[0],
      isRepeatUser
    };
    sendGainSightEvent(
      LIVE_CHAT_GAINSIGHT_EVENTS.CHAT_CONVERSATION_TRIGGERED,
      chatConvTriggerData
    );
    if (!isRepeatUser) {
      localStorage.setItem(
        GAIN_SIGHT_CONSTANTS.IS_REPEAT_USER_CHAT_CONVERSATION_TRIGGERED,
        GAIN_SIGHT_CONSTANTS.TRUE
      );
    }
  }
};

export const LIVE_CHAT_GAINSIGHT_EVENTS = {
  CHAT_WIDGET_LOADED: 'chatWidgetLoadedNew',
  CHAT_WIDGET_BUBBLE_CLICKED: 'chatWidgetBubbleClickedNew',
  CHAT_WIDGET_NUDGE_CLICKED: 'chatWidgetNudgeClickedNew',
  CHAT_CONVERSATION_TRIGGERED: 'chatConvTriggeredNew'
};
export const CHATBOTS_GAINSIGHT_EVENTS = {
  CHATBOT_FLOW_TRIGGERED: 'chatbotFlowTriggeredNew',
  CHATBOT_CLOSED_CHAT: 'chatbotClosedChatNew',
  CHATBOT_CONTACT_FORM_SUBMIT: 'botContactFormSubmitNew',
  CHAT_HANDOFF_TO_AGENT: 'chatHandOffNew',
  CHATBOT_RESTART_FLOW_CLICKED: 'chatbot_restart_flow_clicked',
  CHATBOT_RESTART_CONFIRMED: 'chatbot_restart_confirmed',
  CHATBOT_RESTART_CANCELED: 'chatbot_restart_canceled'
};
export const LiveChatGainSightEventMap = {
  onNudgeClick: LIVE_CHAT_GAINSIGHT_EVENTS.CHAT_WIDGET_NUDGE_CLICKED,
  onChatWidgetLoaded: LIVE_CHAT_GAINSIGHT_EVENTS.CHAT_WIDGET_LOADED,
  onBubbleClick: LIVE_CHAT_GAINSIGHT_EVENTS.CHAT_WIDGET_BUBBLE_CLICKED
};

export const GAIN_SIGHT_CONSTANTS = {
  RESPONSE_STATUS_200: 200,
  IS_REPEAT_USER_CHAT_CONVERSATION_TRIGGERED:
    'isRepeatUserChatConversationTriggered',
  TRUE: 'true',
  SENDER_TYPE_AGENT_BOT: 'AgentBot',
  CHAT_STATUS_OPEN: 'open',
  CHAT_STATUS_RESOLVED: 'resolved'
};

export const SURFACE_KB_IN_CHAT_GS_EVENTS = {
  WIDGET_TAB_CLICKED: 'widgetTabClicked',
  WIDGET_ARTICLE_SEARCH_USED: 'widgetSearchUsed',
  WIDGET_ARTICLE_CLICKED: 'widgetArticleClicked',
  WIDGET_ARTICLE_OPEN: 'widgetOpenArticle'
};
